module.exports = "../dist/frontend/images/white/carousel/europe.svg?49d40656d6a4164e5daa983f7c209cee";